/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import { Remove } from '@material-ui/icons'

// PAGES
import DashboardPage from 'views/Dashboard/Dashboard.js'
import AcounntsListAdmin from 'views/Admin/AcounntsListAdmin.js'
import MenuListAdmin from 'views/Admin/ModuleListAdmin.js'
import ProfilesListAdmin from 'views/Admin/ProfilesListAdmin.js'
import ProfilePrivileges from 'views/Admin/ProfilePrivilegesListAdmin.js'
import CountriesListAdmin from 'views/Admin/CountriesListAdmin.js'
import StatesListAdmin from 'views/Admin/StatesListAdmin.js'
import CitiesListAdmin from 'views/Admin/CitiesListAdmin.js'
import JobsAdmin from "views/Admin/JobsAdmin.js";

const dashboardRoutes = [
  {
    id: 0,
    subId: '',
    path: '/dashboard',
    name: 'Inicio',
    rtlName: 'لوحة القيادة',
    icon: Remove,
    component: DashboardPage,
    layout: '/superadmin',
    submenu: [],
  },
  /* START SUDSCRIPTION*/
  {
    id: 1,
    subId: '',
    path: '',
    name: 'Administración',
    rtlName: '',
    icon: Remove,
    component: '',
    layout: '/superadmin',
    submenu: [
      {
        subId: 1,
        name: 'Perfiles',
        path: '/profilelist',
      },
      {
        subId: 1,
        name: 'Permisos por perfiles',
        path: '/profileprivileges',
      },
      {
        subId: 1,
        name: 'Módulos',
        path: '/modules',
      },
      {
        subId: 1,
        name: 'Paises',
        path: '/countries',
      },
      {
        subId: 1,
        name: 'Estados',
        path: '/states',
      },
      {
        subId: 1,
        name: 'Ciudades',
        path: '/cities',
      },
      {
        subId: 1,
        name: 'Cargos (Administración)',
        path: '/jobsadmin',
      },
    ],
  },
  {
    // SUBMENU Profiles list
    id: '',
    subId: 1,
    path: '/profilelist',
    name: '',
    rtlName: '',
    icon: '',
    component: ProfilesListAdmin,
    layout: '/superadmin',
    submenu: [],
  },
  {
    // SUBMENU MENU list
    id: '',
    subId: 1,
    path: '/modules',
    name: '',
    rtlName: '',
    icon: '',
    component: MenuListAdmin,
    layout: '/superadmin',
    submenu: [],
  },
  {
    // SUBMENU PROFILE/PRIVILEGES list
    id: '',
    subId: 1,
    path: '/profileprivileges',
    name: '',
    rtlName: '',
    icon: '',
    component: ProfilePrivileges,
    layout: '/superadmin',
    submenu: [],
  },
  {
    // SUBMENU COUNTRIES list
    id: '',
    subId: 1,
    path: '/countries',
    name: '',
    rtlName: '',
    icon: '',
    component: CountriesListAdmin,
    layout: '/superadmin',
    submenu: [],
  },
  {
    // SUBMENU STATES list
    id: '',
    subId: 1,
    path: '/states',
    name: '',
    rtlName: '',
    icon: '',
    component: StatesListAdmin,
    layout: '/superadmin',
    submenu: [],
  },
  {
    // SUBMENU CITIES list
    id: '',
    subId: 1,
    path: '/cities',
    name: '',
    rtlName: '',
    icon: '',
    component: CitiesListAdmin,
    layout: '/superadmin',
    submenu: [],
  },
   {
    id: '',
    subId: 1,
    path: "/jobsadmin",
    name: '',
    rtlName: '',
    icon: '',
    component: JobsAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    id: 0,
    subId: '',
    path: '/accounts',
    name: 'Cuentas',
    rtlName: 'لوحة القيادة',
    icon: Remove,
    component: AcounntsListAdmin,
    layout: '/superadmin',
    submenu: [],
  }, 
]

export default dashboardRoutes
